<template>
  <div>
    <div
      class="div-message"
      :class="{ 'div-message-modal-open': modal.open }"
      v-if="storageNotification.length > 0"
    >
      <Alert type="danger">
        <div class="side-by-side" v-for="(notification, index) in storageNotification" :key="index">
          <div class="side-by-side text">
            {{ notification.message }}
          </div>
        </div>
        <div class="progress-bar-container">
          <div class="progress-bar" :style="{ width: progressWidth + '%' }"></div>
        </div>
      </Alert>
    </div>
  </div>
</template>

<script>
import Alert from "../layout/Alert.vue";
import { mapState, mapMutations } from "vuex";

export default {
  components: { Alert },
  name: "Messages",
  data() {
    return {
      maxSeconds: 10,
      countdown: 10,
      storageNotification: [],
      progressWidth: 100,
    };
  },
  computed: {
    ...mapState("generic", ["notifications", "modal"]),
  },
  watch: {
    notifications() {
      if (this.notifications.length > 0) {
        this.storageNotification = this.notifications;
        this.countdown = this.maxSeconds;
        this.progressWidth = 100;
        this.startCountdown();
      }
    },
    countdown(newCountdown) {
      if (newCountdown === 0) {
        this.storageNotification = [];
        this.removeNotificarions();
      }
    },
  },
  methods: {
    ...mapMutations("generic", ["removeNotificarions"]),

    startCountdown() {
      clearInterval(this.countdownInterval);
      this.countdownInterval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
          this.updateProgressBar();
        } else {
          clearInterval(this.countdownInterval);
        }
      }, 1000);
    },

    updateProgressBar() {
      // Atualiza a largura da barra de progresso
      this.progressWidth = (this.countdown / this.maxSeconds) * 100;
    },
  },
  beforeDestroy() {
    clearInterval(this.countdownInterval);
  },
};
</script>

<style scoped>
.div-message {
  position: fixed;
  top: 16px;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 40vw;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  transition: all 0.5s ease !important;
  z-index: 9999;
}

.div-message-modal-open {
  top: 16px;
}

.side-by-side {
  display: flex;
  justify-content: space-between;
}

.text {
  margin-right: 10px;
  word-break: break-word;
}

.progress-bar-container {
  width: 100%;
  height: 3px;
  background-color: #e0e0e0;
  border-radius: 5px;
  margin-top: 10px;
}

.progress-bar {
  height: 100%;
  background-color: #FF0201;
  border-radius: 50px;
  transition: width 1s ease-out;
}

.div-countdown {
  margin-top: 10px;
  font-size: 16px;
}

@media (max-width: 768px) {
  .div-message {
    top: 12px;
    right: 12px;
    left: 12px;
    width: auto;
    max-height: calc(100vh - 24px);
  }
}
</style>
